import type { FetusWeight } from "@/types/pregnancy"
import { API_ROOT, HttpClient } from "@/api/httpClient"

export interface FetusWeightPayload {
	/** in grammi */
	weight: number
}

export default {
	list(patientId: number, pregnancyId: number, fetusId: number) {
		return HttpClient.get<FetusWeight[]>(
			`${API_ROOT}/patients/${patientId}/pregnancies/${pregnancyId}/fetuses/${fetusId}/weights`
		)
	},
	create(patientId: number, pregnancyId: number, fetusId: number, payload: FetusWeightPayload) {
		return HttpClient.post<FetusWeight>(
			`${API_ROOT}/patients/${patientId}/pregnancies/${pregnancyId}/fetuses/${fetusId}/weights`,
			payload
		)
	},
	update(patientId: number, pregnancyId: number, fetusId: number, weightId: number, payload: FetusWeightPayload) {
		return HttpClient.put<FetusWeight>(
			`${API_ROOT}/patients/${patientId}/pregnancies/${pregnancyId}/fetuses/${fetusId}/weights/${weightId}`,
			payload
		)
	},
	delete(patientId: number, pregnancyId: number, fetusId: number, weightId: number) {
		return HttpClient.delete(
			`${API_ROOT}/patients/${patientId}/pregnancies/${pregnancyId}/fetuses/${fetusId}/weights/${weightId}`
		)
	}
}
